import { atom } from 'jotai';

export type PhoneVerificationStep = 'prompt' | 'otp' | 'success';

/** Analytics data structure from order status response */
export interface OrderAnalytics {
  orderId: string;
  name: string;
  totalAmount: number;
  currency: string;
  products: Array<{
    name: string;
    quantity: number;
  }>;
}

export interface PhoneVerificationState {
  /** Whether to show the phone verification prompt */
  isOpen: boolean;
  /** Current step in the verification flow */
  step: PhoneVerificationStep;
  /** Phone number to verify (editable) */
  phoneNumber: string;
  /** Whether the phone number is in edit mode */
  isEditingPhone: boolean;
  /** Order data for displaying the summary */
  orderData: {
    orderId: string;
    orderName: string;
    totalAmount: number;
    currency: string;
    products: Array<{
      name: string;
      quantity: number;
    }>;
  } | null;
  /** The redirect callback to execute after skip/complete */
  pendingRedirect: (() => void) | null;
}

export const phoneVerificationAtom = atom<PhoneVerificationState>({
  isOpen: false,
  step: 'prompt',
  phoneNumber: '',
  isEditingPhone: false,
  orderData: null,
  pendingRedirect: null,
});

/** Helper to extract order data from analytics response */
export function extractOrderDataFromAnalytics(
  analytics: OrderAnalytics,
): PhoneVerificationState['orderData'] {
  return {
    orderId: analytics.orderId,
    orderName: analytics.name,
    totalAmount: analytics.totalAmount,
    currency: analytics.currency,
    products: analytics.products.map((p) => ({
      name: p.name,
      quantity: p.quantity,
    })),
  };
}
